export default {
    findClassList: {
        method: 'get',
        url: 'units/classes{/id}'
    },
    findClassSchedulesList: {
        method: 'post',
        url: 'units/classschedules'
    },
    findSchedulesList: {
        method: 'get',
        url: 'units/schedules{/idClassSchedule}'
    },
    doSchedule: {
        method: 'post',
        url: 'members/doSchedule'
    },
    removeSchedule: {
        method: 'post',
        url: 'members/removeSchedule'
    },
    updateUnit: {
        method: 'post',
        url: 'units'
    },
}